module.exports = __webpack_public_path__ + "img/v2.26731f35.png";